// gameStorage.js
import firebase from "firebase/app";
import "firebase/firestore";

const firestore = firebase.firestore();

const OFFLINE_EVENTS_KEY = "offline_basket_events";
const GAME_STATE_KEY = "local_basket_game_state";
const GAME_ID_KEY = "gameId";
const CLOCK_TIMESTAMPS_KEY = "clock_timestamps";

export const initGame = (gameId) => {
    localStorage.setItem(GAME_ID_KEY, gameId);
};

export const saveEvent = async (event) => {
    console.log("saveEvent", event)
    const gameId = localStorage.getItem(GAME_ID_KEY);
    const enhancedEvent = {
        ...event,
        timestamp: Date.now(),
    };

    //const offline = JSON.parse(localStorage.getItem(OFFLINE_EVENTS_KEY)) || [];
    //offline.push(enhancedEvent);
    //localStorage.setItem(OFFLINE_EVENTS_KEY, JSON.stringify(offline));

    if (navigator.onLine) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        const eventosRef = gameRef.collection("eventos");
        await eventosRef.add(enhancedEvent);

        //const updatedOffline = offline.slice(1);
        //localStorage.setItem(OFFLINE_EVENTS_KEY, JSON.stringify(updatedOffline));
    }
};

export const syncOfflineEvents = async () => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    const offline = JSON.parse(localStorage.getItem(OFFLINE_EVENTS_KEY)) || [];

    if (navigator.onLine && offline.length > 0) {
        const batch = firestore.batch();
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        const eventosRef = gameRef.collection("eventos");

        offline.forEach((event) => {
            const newRef = eventosRef.doc();
            batch.set(newRef, event);
        });

        await batch.commit();
        localStorage.removeItem(OFFLINE_EVENTS_KEY);
    }
};

export const getGameState = () => {
    const state = localStorage.getItem(GAME_STATE_KEY);
    return state ? JSON.parse(state) : null;
};

export const setGameState = (state) => {
    localStorage.setItem(GAME_STATE_KEY, JSON.stringify(state));

    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (navigator.onLine && gameId) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        gameRef.set({ estado: state }, { merge: true });
    }
};

export const fetchGameStateFromFirestore = async () => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (!gameId || !navigator.onLine) return null;

    const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
    const doc = await gameRef.get();
    if (doc.exists && doc.data().estado) {
        const state = doc.data().estado;
        localStorage.setItem(GAME_STATE_KEY, JSON.stringify(state));
        return state;
    }
    return null;
};

export const saveClockTimestamps = ({ startTimestamp, pauseTimestamp }) => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    const data = { startTimestamp, pauseTimestamp };
    localStorage.setItem(CLOCK_TIMESTAMPS_KEY, JSON.stringify(data));

    if (navigator.onLine && gameId) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        gameRef.set({ reloj: data }, { merge: true });
    }
};

export const getClockTimestamps = async () => {
    const local = localStorage.getItem(CLOCK_TIMESTAMPS_KEY);
    if (local) return JSON.parse(local);

    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (navigator.onLine && gameId) {
        const gameRef = firestore.collection("teamGames").doc("basketball").collection("partidos").doc(gameId);
        const doc = await gameRef.get();
        if (doc.exists && doc.data().reloj) {
            const reloj = doc.data().reloj;
            localStorage.setItem(CLOCK_TIMESTAMPS_KEY, JSON.stringify(reloj));
            return reloj;
        }
    }

    return { startTimestamp: null, pauseTimestamp: null };
};

export const calcularTiempoAcumulado = async (cuarto) => {
    const gameId = localStorage.getItem(GAME_ID_KEY);
    if (!navigator.onLine || !gameId) return 0;

    const eventosRef = firestore
        .collection("teamGames")
        .doc("basketball")
        .collection("partidos")
        .doc(gameId)
        .collection("eventos");

    const snapshot = await eventosRef
        .where("cuarto", "==", parseInt(cuarto))
        .where("tipo", "in", ["inicio_crono", "pausa_crono"])
        .orderBy("timestamp", "asc")
        .get();

    const eventos = snapshot.docs.map((d) => d.data());
    let total = 0;
    let start = null;

    for (const e of eventos) {
        if (e.tipo === "inicio_crono") {
            start = e.timestamp;
        } else if (e.tipo === "pausa_crono" && start !== null) {
            total += e.timestamp - start;
            start = null;
        }
    }

    if (start !== null) {
        total += Date.now() - start; // sigue corriendo
    }

    return Math.floor(total / 1000); // segundos
};


export function generarGameStats(eventos, gameData) {
    const resumen = {
        currentPeriod: 1,
        clock: {
            tiempoSegundos: 0,
            runningClock: false,
            timestampClock: 0
        }

    }



    resumen["A"] = {
        totalPuntos: 0,
        porCuarto: {},  // {1: 10, 2: 5, ...}
        players: gameData.estado[`teamAInfo`].players
            .reduce((acc, player) => {
                acc[player.number] = {
                    ...player, playing: false,
                    totalPuntos: 0,
                    mas1: 0,
                    mas2: 0,
                    mas3: 0,
                    totalFaltas: 0,
                    totalViolation: 0,
                    totalAssist: 0,
                    totalRebound: 0,
                    teamKey: "A",
                    porCuarto: {}  // {1: {puntos: 0, faltas: 0}, ...}
                }
                return acc;
            }, {}),
        faltas: 0,
        faltasPorcuarto: {}
    };
    resumen["B"] = {
        totalPuntos: 0,
        porCuarto: {},  // {1: 10, 2: 5, ...}
        players: gameData.estado[`teamBInfo`].players
            .reduce((acc, player) => {
                acc[player.number] = {
                    ...player, playing: false,
                    totalPuntos: 0,
                    mas1: 0,
                    mas2: 0,
                    mas3: 0,
                    totalFaltas: 0,
                    totalViolation: 0,
                    totalAssist: 0,
                    totalRebound: 0,
                    teamKey: "B",
                    porCuarto: {}  // {1: {puntos: 0, faltas: 0}, ...}
                }
                return acc;
            }, {}),
        faltas: 0,
        faltasPorcuarto: {}
    };
    const eventosSort = eventos.sort((a, b) => a.timestamp - b.timestamp);
    for (const evento of eventosSort) {

        const { tipo, equipo, numero, cantidad = 1, cuarto, numberOut, tiempoSegundos, timestamp } = evento;
        console.log("evento", tipo);

        if (tipo === "cambio_periodo") {
            console.log("cambio_periodo", cuarto, JSON.stringify(resumen["A"].players))
            resumen.currentPeriod = cuarto;
            //setCurrentPeriod(cuarto);


            // saco a todos los jugadores por cambio de cuarto
            resumen["A"].players = Object.fromEntries(
                Object.entries(resumen["A"].players).map(([key, value]) => [
                    key,
                    { ...value, playing: false }
                ])
            );
            resumen["B"].players = Object.fromEntries(
                Object.entries(resumen["B"].players).map(([key, value]) => [
                    key,
                    { ...value, playing: false }
                ])
            );
            // resumen["B"].players = Object.values(resumen["B"].players).map((a) => ({ [a.number]: { ...a, playing: false } }))

        }


        if (tipo === "inicio_crono") {
            console.log("inicio_crono", tiempoSegundos, timestamp);
            resumen.clock.tiempoSegundos = tiempoSegundos;
            resumen.clock.runningClock = true;
            resumen.clock.timestampClock = timestamp;
        }
        if (tipo === "pausa_crono") {
            console.log("pausa_crono", tiempoSegundos, timestamp);
            resumen.clock.tiempoSegundos = tiempoSegundos;
            resumen.clock.runningClock = false;
            resumen.clock.timestampClock = timestamp;
        }


        if (!equipo || !cuarto || !["punto", "falta", "quitar_punto", "quitar_falta", "cambio", "cambiosale", "violation", "quitar_violation", "assist", "quitar_assist", "rebound", "quitar_rebound"].includes(tipo)) continue;



        const esQuitar = tipo.startsWith("quitar_");
        const tipoBase = tipo.replace("quitar_", ""); // "punto" o "falta"
        const valor = esQuitar ? -cantidad : cantidad;


        // Inicializar estructuras

        console.log("resumen", resumen);
        if (!resumen[equipo].porCuarto[cuarto]) {
            resumen[equipo].porCuarto[cuarto] = 0;
        }
        if (!resumen[equipo].faltasPorcuarto[cuarto]) {
            resumen[equipo].faltasPorcuarto[cuarto] = 0;
        }

        if (numero) {
            if (!resumen[equipo].players[numero]) {
                resumen[equipo].players[numero] = {
                    number: numero,
                    playing: false,
                    totalPuntos: 0,
                    totalFaltas: 0,
                    porCuarto: {}  // {1: {puntos: 0, faltas: 0}, ...}
                };
            }

            if (!resumen[equipo].players[numero].porCuarto[cuarto]) {
                resumen[equipo].players[numero].porCuarto[cuarto] = {
                    puntos: 0,
                    faltas: 0
                };
            }

            if (tipoBase === "punto") {
                resumen[equipo].players[numero].totalPuntos += valor;
                if (valor === 1) {
                    console.log("mas1", valor)
                    resumen[equipo].players[numero].mas1++;
                } else if (valor === 2) {
                    resumen[equipo].players[numero].mas2++;
                } else if (valor === 3) {
                    resumen[equipo].players[numero].mas3++;
                }
                else if (valor === -1) {
                    console.log("mas1", valor)
                    resumen[equipo].players[numero].mas1--;
                } else if (valor === -2) {
                    resumen[equipo].players[numero].mas2--;
                } else if (valor === -3) {
                    resumen[equipo].players[numero].mas3--;
                }
                resumen[equipo].players[numero].porCuarto[cuarto].puntos += valor;
            } else if (tipoBase === "falta") {
                resumen[equipo].players[numero].totalFaltas += valor;
                resumen[equipo].players[numero].porCuarto[cuarto].faltas += valor;
            } else if (tipoBase === "violation") {
                console.log("violation", valor)
                resumen[equipo].players[numero].totalViolation += valor;
                resumen[equipo].players[numero].porCuarto[cuarto].violation += valor;
            } else if (tipoBase === "assist") {
                console.log("assist", valor)
                resumen[equipo].players[numero].totalAssist += valor;
                resumen[equipo].players[numero].porCuarto[cuarto].assist += valor;
            } else if (tipoBase === "rebound") {
                console.log("rebound", valor)
                resumen[equipo].players[numero].totalRebound += valor;
                resumen[equipo].players[numero].porCuarto[cuarto].rebound += valor;

            }
        }

        // Acumular a nivel de equipo
        if (tipoBase === "punto") {
            resumen[equipo].totalPuntos += valor;

            resumen[equipo].porCuarto[cuarto] += valor;
        }
        if (tipoBase === "falta") {
            resumen[equipo].faltas += valor;
            resumen[equipo].faltasPorcuarto[cuarto] += valor;
        }
        if (tipo === "cambio") {
            console.log("cambio_Jugador", numero, numberOut);

            resumen[equipo].players[numero].playing = true;
            if (resumen[equipo].players[numberOut]) {
                resumen[equipo].players[numberOut].playing = false;
            }
        }
        if (tipo === "cambiosale") {
            console.log("cambio_Jugador SALE", numero, numberOut);
            resumen[equipo].players[numero].playing = false;
        }



    }


    return resumen;
}
